import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import PartnerAssociationFilterComponent from "./PartnerAssociationFilterComponent";
import PartnerAssociationSelectionComponent from "./PartnerAssociationSelectionComponent";
import { Pagination } from "@totalsoft/rocket-ui";

const PartnerAssociationModalEditComponent = ({
  filterList,
  setFilterList,
  partnerAssociationModalState,
  partnerData,
  partnerDataCount,
  partnerDataLoading,
  handleAssociate,
  pager,
  onChangePage,
  onChangeRowsPerPage
}) => {
  return (
    <Grid container spacing={2} sx={{ p: 1 }}>
      <PartnerAssociationFilterComponent filterList={filterList} setFilterList={setFilterList} />
      <Grid item xs={12}>
        <PartnerAssociationSelectionComponent
          partnerData={partnerData}
          handleAssociate={handleAssociate}
          isSingleSelection={partnerAssociationModalState.data.singleSelection}
        />
      </Grid>
      <Grid item xs={12}>
        <Pagination
          loading={partnerDataLoading}
          count={partnerDataCount}
          pageSize={pager.pageSize}
          page={pager.page - 1}
          onRefresh={() => onChangePage(0)}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />
      </Grid>
    </Grid>
  );
};

PartnerAssociationModalEditComponent.propTypes = {
  filterList: PropTypes.array.isRequired,
  setFilterList: PropTypes.func.isRequired,
  partnerAssociationModalState: PropTypes.object.isRequired,
  partnerData: PropTypes.array.isRequired,
  partnerDataCount: PropTypes.number.isRequired,
  partnerDataLoading: PropTypes.bool.isRequired,
  handleAssociate: PropTypes.func.isRequired,
  pager: PropTypes.object.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired
};

export default PartnerAssociationModalEditComponent;
